module.exports = __webpack_public_path__ + "static/media/lift.665ce089.png";